import type { TurnId } from "@cmmd-forge/contracts";
import type { ActivePlanState } from "../../session-logic";

export interface ComposerPlanProgress {
  readonly step: string;
  readonly completedSteps: number;
  readonly totalSteps: number;
  readonly steps: Readonly<ActivePlanState["steps"]>;
  readonly stepKeys: readonly string[];
  readonly identity: string;
}

export function deriveComposerPlanProgress(
  plan: ActivePlanState | null,
  latestTurnId: TurnId | null,
  settled: boolean,
): ComposerPlanProgress | null {
  if (!plan || settled || !latestTurnId || plan.turnId !== latestTurnId || plan.steps.length === 0)
    return null;
  const current =
    plan.steps.find((step) => step.status === "inProgress") ??
    plan.steps.find((step) => step.status === "pending");
  return {
    identity: `${plan.turnId}:${JSON.stringify(plan.steps.map((step) => step.step))}`,
    step: current?.step ?? "Plan complete",
    completedSteps: plan.steps.filter((step) => step.status === "completed").length,
    totalSteps: plan.steps.length,
    steps: plan.steps,
    stepKeys: plan.steps.map((step, index) => `${plan.turnId}:${index}:${step.step}`),
  };
}
